'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["active", "hovered", "pointySide"];
import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import styled from 'styled-components';
import ActiveProvider from '../providers/ActiveProvider';
import HoverProvider from '../providers/HoverProvider';
import UIClickable from './UIClickable';
import { BUTTON_DEFAULT_FONT_SIZE, BUTTON_RADIUS } from 'HubStyleTokens/sizes';
import { MONOLITH } from 'HubStyleTokens/colors';
import { INPUT_VERTICAL_ALIGNMENT } from 'HubStyleTokens/misc';
import { setUiTransition } from '../utils/Styles';
import { hidden } from '../utils/propTypes/decorators';
import { rgba } from '../core/Color';
import { jsx as _jsx } from "react/jsx-runtime";
const FAB_HEIGHT = '50px';
const Fab = styled(props => {
  const rest = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsx(UIClickable, Object.assign({}, rest));
}).withConfig({
  displayName: "UIFloatingActionButton__Fab",
  componentId: "mcaf7m-0"
})(["align-items:center;border-radius:20px;border-bottom-left-radius:", ";border-bottom-right-radius:", ";box-shadow:0 5px 20px 0 rgba(12,73,84,0.2);display:inline-flex;font-size:", ";line-height:normal;min-height:", ";padding:0 10px;position:relative;", ";user-select:none;vertical-align:", ";&::after{content:'';display:block;height:", ";margin-left:-1px;width:1px;}&::before{background-color:", ";border-radius:inherit;bottom:0;content:'';display:", ";left:0;position:absolute;right:0;top:0;}"], props => props.pointySide === 'bottom-left' && BUTTON_RADIUS, props => props.pointySide === 'bottom-right' && BUTTON_RADIUS, BUTTON_DEFAULT_FONT_SIZE, FAB_HEIGHT, setUiTransition('background'), INPUT_VERTICAL_ALIGNMENT, FAB_HEIGHT, rgba(MONOLITH, 0.1), props => props.active ? 'block' : 'none');
class UIFloatingActionButton extends PureComponent {
  render() {
    return /*#__PURE__*/_jsx(HoverProvider, Object.assign({}, this.props, {
      children: hoverProviderProps => /*#__PURE__*/_jsx(ActiveProvider, Object.assign({}, this.props, {
        children: activeProviderProps => /*#__PURE__*/_jsx(Fab, Object.assign({}, this.props, hoverProviderProps, activeProviderProps))
      }))
    }));
  }
}
UIFloatingActionButton.propTypes = {
  children: PropTypes.node,
  hovered: hidden(PropTypes.bool),
  pointySide: PropTypes.oneOf(['bottom-left', 'bottom-right'])
};
UIFloatingActionButton.defaultProps = {
  pointySide: 'bottom-left'
};
UIFloatingActionButton.displayName = 'UIFloatingActionButton';
export default UIFloatingActionButton;